
const validateOTP = (form) => {
    let errors = {};
    if (!form.document) errors.document = 'DNI es requerido';
    if (!form.token) errors.token = 'OTP es requerido';
  
    //validate errors for button 
  
    if (errors.document || errors.token) {
      errors.validate = true;
    } else {
      errors.validate = false;
    }
  
    return errors;
  };
  
  
  export default validateOTP;
  